import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { fonts } from '../../theme'

const styles = {
  title: {
    color: '#fff',
    fontWeight: '700',
    fontFamily: fonts.primary,
  }
};

const Title = (props) => {
  const { classes } = props;

  return (
    <Typography gutterBottom 
      className={classes.title}
      variant="display2" 
      component="h1"
      style={{color: props.color,fontSize:props.fontSize}}
    >
        {props.children}
    </Typography>
  )
}

export default withStyles(styles)(Title);


// WEBPACK FOOTER //
// ./src/elements/Text/Title.js